import { BellIcon, ChevronDownIcon, MessageSquareIcon } from "lucide-react";
import React from "react";
import {
  Avatar,
  AvatarFallback,
  AvatarImage,
} from "../../components/ui/avatar";
import { Button } from "../../components/ui/button";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "../../components/ui/card";
import { Separator } from "../../components/ui/separator";
// import { ToggleGroup, ToggleGroupItem } from "../../components/ui/toggle-group";
import { Switch } from "../../components/ui/switch";
import { ToggleGroup, ToggleGroupItem } from "../../components/ui/toggle-group";
import { Header } from "../../components/Header/Header";
import { ComponentHeader } from "../../components/Header/ComponentHeader";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

export const Settings = (): JSX.Element => {
  const navigate = useNavigate();
  const location = useLocation();
  const countryMatch = location.pathname.match(/^\/([a-z]{2,})\//i);
  const country = countryMatch ? countryMatch[1] : "in";
  const { t } = useTranslation();

  const handleGoBack = () => {
    navigate(`/${country}/my-predictions`);
  };
  // Data for language options
  const languageOptions = [
    { id: "english", label: "english", selected: true },
    // { id: "hindi", label: "hindi", selected: false },
  ];

  // Data for theme options
  const themeOptions = [
    { id: "dark", label: "darkMode", selected: false },
    { id: "light", label: "lightMode", selected: true },
  ];

  // Data for notification settings
  const notificationSettings = [
    {
      id: "whatsapp",
      title: "receiveOnWhatsapp",
      description: "getUpdatesOnWhatsapp",
      icon: "https://c.animaapp.com/m9tuf23zBCLpLe/img/icon-whatsapp.svg",
      enabled: false,
    },
    {
      id: "sms",
      title: "receiveSms",
      description: "getUpdatesOnSms",
      icon: <MessageSquareIcon className="h-6 w-6" data-testid="message-square-icon" />,
      enabled: true,
    },
  ];

  return (
    <div>
      <Header className="hidden sm:flex"/>
      <ComponentHeader name={t('settings')} handleClick={handleGoBack} data-testid="back-button"/>
      <div className="bg-[#fcfcfc] flex flex-row justify-center w-full">
        <div className="bg-[#fcfcfc] w-full relative">

          {/* Sidebar */}
          <div className="fixed left-0 top-[60px]  hidden sm:flex  flex-col w-[100px] h-[calc(100vh-60px)] items-start gap-5 p-2.5 bg-primary-new500">
            <div 
              className="cursor-pointer relative w-20 h-20 bg-[#014224] rounded-[10px] flex items-center justify-center" 
              onClick={handleGoBack}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  handleGoBack();
                }
              }}
              role="button"
              tabIndex={0}
              aria-label={t('back')}
            >
              <img
                className="w-11 h-11"
                alt={t('iconPrediction')}
                src="https://c.animaapp.com/m9tuf23zBCLpLe/img/icon-prediction.svg"
              />
            </div>
          </div>

          {/* Main content */}
          <div role="main" className="sm:ml-[100px] py-5 px-[24px]  sm:w-[calc(100%-100px)] sm:h-[calc(100dvh-60px)] overflow-auto">
            {/* <Card className="w-full sm:shadow-[0px_0px_10px_2px_#0000001a]"> */}
              <CardContent className="p-0 pb-[36px] sm:pb-6 sm:p-6 space-y-6">
                {/* Preferred Language */}
                <Card className="border-b sm:border border-[#d3d3d3] sm:rounded-[10px]">
                  <CardContent className="px-0 pt-0 pb-2 sm:p-4">
                    <h3 className="font-medium text-black mb-4 ml-3 mt-2">
                      {t('language')}
                    </h3>
                    <ToggleGroup
                      type="single"
                      defaultValue="english"
                      className="flex gap-2 justify-start" 
                    >
                      {languageOptions.map((option) => (
                        <ToggleGroupItem
                          key={option.id}
                          value={option.id}
                          className={`px-5 py-2 rounded-lg text-xs font-medium ${option.selected
                              ? "bg-[#0071CD] text-white"
                              : "bg-[#EAF6FF] text-black"
                            }`}
                        >
                          {t(option.label)}
                        </ToggleGroupItem>
                      ))}
                    </ToggleGroup>
                  </CardContent>
                </Card>

                {/* Theme Preferences */}
                {/* <Card className="border-b sm:border border-[#d3d3d3] sm:rounded-[10px]">
                  <CardContent className="px-0 pt-0 pb-2 sm:p-4">
                    <h3 className="font-medium text-black mb-4">
                      {t('theme')}
                    </h3>
                    <ToggleGroup
                      type="single"
                      defaultValue="light"
                      className="flex gap-2 justify-start"
                    >
                      {themeOptions.map((option) => (
                        <ToggleGroupItem
                          key={option.id}
                          value={option.id}
                          className={`px-5 py-2 rounded-lg text-xs font-medium ${option.selected
                              ? "bg-[#0071CD] text-white"
                              : "bg-[#EAF6FF] text-black"
                            }`}
                        >
                          {t(option.label)}
                        </ToggleGroupItem>
                      ))}
                    </ToggleGroup>
                  </CardContent>
                </Card> */}

                {/* Notification Settings */}
                {/* <div className="space-y-4">
                  <h3 className="font-medium text-black">
                    {t('notifications')}
                  </h3>

                  {notificationSettings.map((setting) => (
                    <Card
                      key={setting.id}
                      className="border border-[#d2d2d2] rounded-md"
                    >
                      <CardContent className="p-4 flex items-center gap-3.5">
                        <div className="bg-[#EAF6FF] p-4 rounded-lg flex items-center justify-center">
                          {typeof setting.icon === "string" ? (
                            <img
                              src={setting.icon}
                              alt={t('icon')}
                              className="w-6 h-6"
                            />
                          ) : (
                            setting.icon
                          )}
                        </div>

                        <div className="flex-1">
                          <h4 className="text-sm sm:text-lg text-black font-normal">
                            {t(setting.title)}
                          </h4>
                          <p className="text-xs sm:text-sm  text-[#7C7D7B] sm:text-neutrals-500">
                            {t(setting.description)}
                          </p>
                        </div>

                        <Switch checked={setting.enabled} />
                      </CardContent>
                    </Card>
                  ))}
                </div> */}
              </CardContent>

              <CardFooter role="contentinfo" className="px-6 py-4 flex justify-center sm:justify-end fixed sm:static bottom-0 left-0 right-0 shadow-mobile-footer-shadow bg-white sm:bg-none sm:shadow-none">
                <Button className="bg-primary-new500 text-white rounded-[100px] px-3 py-2.5 w-full sm:w-auto">
                  {t('saveChanges')}
                </Button>
              </CardFooter>
            {/* </Card> */}
          </div>
        </div>
      </div>
    </div>
  );
};

